import React from 'react';

import { LinearProgress, Switch } from '@material-ui/core';

import { ErrorOutlineIcon } from 'assets/icons/alert';
import EditIcon from 'assets/icons/edit';

import { isNumeric } from '../utils';
import { Enum } from './enum';

export class CampaignGroupStatus extends Enum {
    #icon;

    static items = [];

    static UNDEFINED = new CampaignGroupStatus('', -1);
    static FAILED = new CampaignGroupStatus('FAILED', 0, () => <ErrorOutlineIcon />);
    static INPROGRESS = new CampaignGroupStatus(
        'IN PROGRESS',
        2,
        <LinearProgress color='primary' style={{ width: '35px' }} />
    );
    static PUBLISHED = new CampaignGroupStatus('PUBLISHED', 3, <Switch color='primary' checked={true} dir='rtl' />);
    static MISCELLANEOUS = new CampaignGroupStatus('PARTIAL', 4, <Switch color='primary' checked={false} dir='rtl' />);

    static DRAFT = new CampaignGroupStatus('DRAFT', 21, <EditIcon fontSize='small' />);
    static ENQUEUED_TO_PUBLISH = new CampaignGroupStatus(
        'QUEUED',
        20,
        <LinearProgress color='primary' style={{ width: '35px' }} />
    );

    constructor(name, value, icon) {
        super(name, value);

        this.#icon = icon;
        CampaignGroupStatus.items.push(this);
    }

    /**
     *
     */

    equals(other) {
        return this.value === other.value && this.name === other.name;
    }

    /**
     *
     */

    get icon() {
        return this.#icon;
    }

    /**
     *
     */

    static find(criteria) {
        if (isNumeric(criteria)) {
            return CampaignGroupStatus.items.find((v) => v.value === Number(criteria));
        }

        return CampaignGroupStatus.items.find((v) => v.name === criteria);
    }

    /**
     *
     */

    static contains(criteria) {
        const status = CampaignGroupStatus.find(criteria);

        return !!status;
    }

    /**
     *
     */

    static get(criteria) {
        return CampaignGroupStatus.find(criteria) || CampaignGroupStatus.UNDEFINED;
    }
}
